import React, { useState, useEffect } from 'react';
import { fetchChains } from '../../../../modules/chains'

function ChainPicker({ chain_id, update }) {
  const [selectedChain, setSelectedChain] = useState(chain_id || '');
  const [chains, setChains] = useState([]);

  useEffect(() => {
    fetchChains()
      .then((data) => {
        setChains(data);
      })
  }, [])

  const handleChainChange = (event) => {
    setSelectedChain(event.target.value);
    update(event.target.value);
  };

  return (
    <select
      value={selectedChain}
      onChange={handleChainChange}
      className="h-[40px] shadow-sm border border-gray-400 border text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
      style={{'width': '150px'}}
      id='states'
    >
      <option value="">Select a chain</option>
      <option key={'none'} value={'none'}>
        NONE
      </option>
      {chains.map((chain) => (
        <option key={chain.id} value={chain.id}>
          {chain.name}
        </option>
      ))}
    </select>
  );
};

export default ChainPicker;
